export enum SignMethod{
    BankId = 'swedish_bankid',
    Standard = 'standard_esign'
}